import { AnimatePresence } from '@eversports/klimt-utilities/framer-motion'

import Footer from '../../components/Footer'
import Header from '../../components/Header'

import DataSubProcessors from './DataSubProcessors'

const DataSubProcessorsScreen = () => {
  return (
    <>
      <Header />
      <AnimatePresence mode="wait">
        <DataSubProcessors />
      </AnimatePresence>
      <Footer />
    </>
  )
}

export default DataSubProcessorsScreen
